import isSSR from '@calm/web-common/dist/isSSR';

export const LOCAL_SELF_HARM_SCORE_KEY = 'shs';

const useLocalSelfHarmScore = (): [number, (score?: number) => void] => {
    const selfHarmScore = isSSR()
        ? 0
        : parseInt(sessionStorage.getItem(LOCAL_SELF_HARM_SCORE_KEY) ?? '0');

    const setSelfHarmScore = (score = 0) => {
        sessionStorage.setItem(LOCAL_SELF_HARM_SCORE_KEY, score.toString());
    };

    return [selfHarmScore, setSelfHarmScore];
};

export default useLocalSelfHarmScore;
